// extracted by css-extract-rspack-plugin
export default {"WarningIcon":"WYJKt"};